<script lang="ts">
  import type { IULink } from "../../../core/types";
  import { ULink } from "../../../core";

  interface ILinksPanel {
    title: string;
    links: IULink[];
  }

  export let data: ILinksPanel;
</script>

<section class="link-panel g-centered">
  <div class="content">
    {#if data.title}
      <h2 class="title">{data.title}</h2>
    {/if}

    <div class="list">
      {#each data.links as link}
        <div class="item">
          <svg class="icon" width="13" height="14" aria-label="link-icon">
            <use xlink:href="#arrow-right" />
          </svg>
          <div class="item__link">
            <ULink class="link" data={link} />
          </div>
        </div>
      {/each}
    </div>
  </div>
</section>

<style lang="scss">
  .link-panel {
    background: $box-color;
    padding-top: 30px;
    padding-bottom: 20px;
    margin-bottom: 30px;

    @include md {
      padding-bottom: 30px;
      margin-bottom: 40px;
    }
  }

  .content {
    padding-left: 20px;
    padding-right: 20px;

    @include md {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .title {
    @include small;
    font-weight: 900;
    color: $text-color;
    margin-bottom: 22px;
  }

  .item {
    @include normal;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &__link {
      margin: 0 0 4px 14px;
    }
  }
</style>
